/**
`com-icon`
@demo demo/index.html
*/
/*
  FIXME(polymer-modulizer): the above comments were extracted
  from HTML and may be out of place here. Review them and
  then delete this comment!
*/
import { PolymerElement, html } from '@polymer/polymer';
import './style/com-icon-style.js'
import '@com/html';
import '@webcomponents/shadycss/entrypoints/apply-shim.js';

class COMIcon extends PolymerElement {

  static get template() {
    return html`
<style include="com-icon-style"></style>
<com-html value="[[value]]"></com-html>
`;
  }

  static get is() { return 'com-icon'; }

  static get properties() {
    return {
      /**
       * Font family
       *
       * @type String
       */
      font: {
        type: String,
        value: 'icon',
        reflectToAttribute: true
      },
      /**
       * @desc theme
       *   - Available - default, hyp
       * @type String
       */
      theme: {
        type: String,
        value: 'default',
        reflectToAttribute: true
      },
      /**
       * @desc icon color theme
       *   - Available - alert
       * @type String
       */
      color: {
        type: String,
        value: '',
        reflectToAttribute: true
      },
      /**
       * Character Code
       */
      value: String
    };
  }
}
window.customElements.define(COMIcon.is, COMIcon);
